var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":{name: 'mass_pending_info', params: {massPendingId: _vm.massPendingId}}}},[_vm._v(_vm._s(_vm.lable)+" "+_vm._s(_vm.massPendingId))])}
var staticRenderFns = []

export { render, staticRenderFns }